import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import hello from "./helloconfig";
import vueClipboards from "vue-clipboards";


Vue.use(vueClipboards);
Vue.config.productionTip = false;
Vue.use(hello);

if (localStorage.token) {
    store.getters.isLoggedIn = true;
}
new Vue({
    router,
    vuetify,
    hello,
    el: "#app",
    render: h => h(App)
}).$mount("#app");
